import { lodash } from './lodash';

export function nameSplitter<T extends string>(name: T): { fName: string; lName: string } {
  if (!name || typeof name !== 'string') {
    return { fName: '', lName: '' }; // Handle empty or invalid input
  }

  const trimmedName = name.trim();

  if (trimmedName.includes(',')) {
    // Case 3: Format is "lName, fName"
    const [lName, fName] = trimmedName.split(',').map((n) => n.trim());
    return { fName: fName || '', lName: lName || '' };
  }

  const parts = trimmedName.split(' ');

  if (parts.length === 1) {
    // Case 1: Only one word (assume it's the last name)
    return { fName: '', lName: parts[0] };
  }

  if (parts.length === 2) {
    // Case 2: Two words (assume first is fName, second is lName)
    return { fName: parts[0], lName: parts[1] };
  }

  // Default case: More than two words (assume first is fName, the rest are lName)
  return { fName: parts[0], lName: parts.slice(1).join(' ') };
}
